import { recipeApi as api } from './recipeApi';
export const addTagTypes = [
  'Cusines',
  'Recipe Categories',
  'RecipeComments',
  'RecipeCommmentsLikes',
  'RecipeFavorites',
  'RecipeLikes',
  'Recipes',
  'Recipe Subcategories',
  'Favorites'
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getCusine: build.query<GetCusineApiResponse, GetCusineApiArg>({
        query: queryArg => ({
          url: `/cusine`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            userId: queryArg.userId
          }
        }),
        providesTags: ['Cusines']
      }),
      getRecipeCategories: build.query<
        GetRecipeCategoriesApiResponse,
        GetRecipeCategoriesApiArg
      >({
        query: queryArg => ({
          url: `/recipeCategories`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby
          }
        }),
        providesTags: ['Recipe Categories']
      }),
      addRecipeComments: build.mutation<
        AddRecipeCommentsApiResponse,
        AddRecipeCommentsApiArg
      >({
        query: queryArg => ({
          url: `/recipeComments`,
          method: 'POST',
          body: queryArg.createRecipeComments
        }),
        invalidatesTags: ['RecipeComments']
      }),
      updateRecipeComments: build.mutation<
        UpdateRecipeCommentsApiResponse,
        UpdateRecipeCommentsApiArg
      >({
        query: queryArg => ({
          url: `/recipeComments/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateRecipeComments
        }),
        invalidatesTags: ['RecipeComments']
      }),
      deleteRecipeComments: build.mutation<
        DeleteRecipeCommentsApiResponse,
        DeleteRecipeCommentsApiArg
      >({
        query: queryArg => ({
          url: `/recipeComments/${queryArg.id}`,
          method: 'DELETE',
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['RecipeComments']
      }),
      addRecipeCommmentsLike: build.mutation<
        AddRecipeCommmentsLikeApiResponse,
        AddRecipeCommmentsLikeApiArg
      >({
        query: queryArg => ({
          url: `/recipeCommmentsLike`,
          method: 'POST',
          body: queryArg.createRecipeCommmentsLike
        }),
        invalidatesTags: ['RecipeCommmentsLikes']
      }),
      getFavoritesCount: build.query<
        GetFavoritesCountApiResponse,
        GetFavoritesCountApiArg
      >({
        query: queryArg => ({
          url: `/favoritesCount`,
          params: {
            userId: queryArg.userId,
            subscriberId: queryArg.subscriberId
          }
        }),
        providesTags: ['Favorites']
      }),
      recipesCategoryList: build.query<
        RecipesCategoryListApiResponse,
        RecipesCategoryListApiArg
      >({
        query: queryArg => ({
          url: `/recipesCategoryList`,
          params: {
            categoryId: queryArg.categoryId,
            filter: queryArg.filter,
            userFolderId: queryArg.userFolderId,
            access: queryArg.access,
            peopleId: queryArg.peopleId
          }
        }),
        providesTags: ['Recipes']
      }),
      addRecipeFavorites: build.mutation<
        AddRecipeFavoritesApiResponse,
        AddRecipeFavoritesApiArg
      >({
        query: queryArg => ({
          url: `/recipeFavorites`,
          method: 'POST',
          body: queryArg.createRecipeFavorites
        }),
        invalidatesTags: ['RecipeFavorites']
      }),
      addRecipeLikes: build.mutation<
        AddRecipeLikesApiResponse,
        AddRecipeLikesApiArg
      >({
        query: queryArg => ({
          url: `/recipeLikes`,
          method: 'POST',
          body: queryArg.createRecipeLikes
        }),
        invalidatesTags: ['RecipeLikes']
      }),
      updateRecipeLikes: build.mutation<
        UpdateRecipeLikesApiResponse,
        UpdateRecipeLikesApiArg
      >({
        query: queryArg => ({
          url: `/recipeLikes/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateRecipeLikes
        }),
        invalidatesTags: ['RecipeLikes']
      }),
      addRecipes: build.mutation<AddRecipesApiResponse, AddRecipesApiArg>({
        query: queryArg => ({
          url: `/recipes`,
          method: 'POST',
          body: queryArg.createRecipes
        }),
        invalidatesTags: ['Recipes']
      }),
      searchRecipes: build.mutation<
        SearchRecipesApiResponse,
        SearchRecipesApiArg
      >({
        query: queryArg => ({
          url: `/recipesSearch`,
          method: 'POST',
          body: queryArg.createSearchRecipes
        }),
        invalidatesTags: ['Recipes']
      }),
      getRecipesById: build.query<
        GetRecipesByIdApiResponse,
        GetRecipesByIdApiArg
      >({
        query: queryArg => ({ url: `/recipes/${queryArg.id}` }),
        providesTags: ['Recipes']
      }),
      updateRecipes: build.mutation<
        UpdateRecipesApiResponse,
        UpdateRecipesApiArg
      >({
        query: queryArg => ({
          url: `/recipes/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateRecipes
        }),
        invalidatesTags: ['Recipes']
      }),
      deleteRecipes: build.mutation<
        DeleteRecipesApiResponse,
        DeleteRecipesApiArg
      >({
        query: queryArg => ({
          url: `/recipes/${queryArg.id}`,
          method: 'DELETE',
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Recipes']
      }),
      bulkDeleteRecipes: build.mutation<
        BulkDeleteRecipesApiResponse,
        BulkDeleteRecipesApiArg
      >({
        query: queryArg => ({
          url: `/recipes/bulkDelete`,
          method: 'POST',
          body: queryArg.bulkRecipes,
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Recipes']
      }),
      bulkPrivateRecipes: build.mutation<
        BulkPrivateRecipesApiResponse,
        BulkPrivateRecipesApiArg
      >({
        query: queryArg => ({
          url: `/recipes/bulkPrivate`,
          method: 'POST',
          body: queryArg.bulkRecipes
        }),
        invalidatesTags: ['Recipes']
      }),
      addRecipeToUserFolder: build.mutation<
        AddRecipeToUserFolderApiResponse,
        AddRecipeToUserFolderApiArg
      >({
        query: queryArg => ({
          url: `/recipes/addToFolder`,
          method: 'POST',
          body: queryArg.recipeFolder
        }),
        invalidatesTags: ['Recipes']
      }),
      bulkAddRecipesToUserFolder: build.mutation<
        BulkAddRecipesToUserFolderApiResponse,
        BulkAddRecipesToUserFolderApiArg
      >({
        query: queryArg => ({
          url: `/recipes/bulkAddToFolder`,
          method: 'POST',
          body: queryArg.recipeFolder
        }),
        invalidatesTags: ['Recipes']
      }),
      getRecipesByUserFolder: build.query<
        GetRecipesByUserFolderApiResponse,
        GetRecipesByUserFolderApiArg
      >({
        query: queryArg => ({
          url: `/recipes/folder/${queryArg.userFolderId}`,
          params: {
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby
          }
        }),
        providesTags: ['Recipes']
      }),
      getRecipeSubcategories: build.query<
        GetRecipeSubcategoriesApiResponse,
        GetRecipeSubcategoriesApiArg
      >({
        query: queryArg => ({
          url: `/recipeSubCategories`,
          params: {
            categoryId: queryArg.categoryId,
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby
          }
        }),
        providesTags: ['Recipe Subcategories']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetCusineApiResponse = /** status 200 Cusines found. */ {
  ok?: boolean;
  data?: Cusine;
  message?: string;
};
export type GetCusineApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** userId */
  userId?: string;
};
export type GetRecipeCategoriesApiResponse = {
  ok?: boolean;
  data?: RecipeCategories;
  message?: string;
};
/** status 200 Returns list of recipe categories with count */
export type GetRecipeCategoriesApiArg = {
  /** Search category name */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort field */
  sortby?: string;
  /** order direction (ASC/DESC) */
  orderby?: string;
};
export type AddRecipeCommentsApiResponse =
  /** status 201 RecipeComments has been created successfully. */ {
    ok?: boolean;
    data?: RecipeComments;
    message?: string;
  };
export type AddRecipeCommentsApiArg = {
  /** RecipeComments that needs to be added to the application */
  createRecipeComments: CreateRecipeComments;
};
export type RecipesCategoryListApiResponse =
  /** status 200 Categories or subcategories retrieved successfully */ {
    ok?: boolean;
    data?: {
      id?: string;
      name?: string;
      recipeCount?: number;
    }[];
    message?: string;
  };
export type RecipesCategoryListApiArg = {
  /** Category ID to get subcategories for. If not provided, returns all categories. */
  categoryId?: string;
  filter?: boolean;
  userFolderId?: string;
  access?: string;
  peopleId?: string;
};
export type UpdateRecipeCommentsApiResponse =
  /** status 200 The RecipeComments's details has been updated successfully */ {
    ok?: boolean;
    data?: RecipeComments;
    message?: string;
  };
export type UpdateRecipeCommentsApiArg = {
  /** ID of the RecipeComments to update */
  id: string;
  /** RecipeComments that needs to be added to the application */
  updateRecipeComments: UpdateRecipeComments;
};
export type DeleteRecipeCommentsApiResponse =
  /** status 200 The RecipeComments's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteRecipeCommentsApiArg = {
  /** ID of the RecipeComments to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type AddRecipeCommmentsLikeApiResponse =
  /** status 201 RecipeCommmentsLike has been created successfully. */ {
    ok?: boolean;
    data?: RecipeCommmentsLike;
    message?: string;
  };
export type AddRecipeCommmentsLikeApiArg = {
  /** RecipeCommmentsLike that needs to be added to the application */
  createRecipeCommmentsLike: CreateRecipeCommmentsLike;
};
export type AddRecipeFavoritesApiResponse =
  /** status 201 RecipeFavorites has been created successfully. */ {
    ok?: boolean;
    data?: RecipeFavorites;
    message?: string;
  };
export type AddRecipeFavoritesApiArg = {
  /** RecipeFavorites that needs to be added to the application */
  createRecipeFavorites: CreateRecipeFavorites;
};
export type AddRecipeLikesApiResponse =
  /** status 201 RecipeLikes has been created successfully. */ {
    ok?: boolean;
    data?: RecipeLikes;
    message?: string;
  };
export type AddRecipeLikesApiArg = {
  /** RecipeLikes that needs to be added to the application */
  createRecipeLikes: CreateRecipeLikes;
};
export type UpdateRecipeLikesApiResponse =
  /** status 200 The RecipeLikes's details has been updated successfully */ {
    ok?: boolean;
    data?: RecipeLikes;
    message?: string;
  };
export type UpdateRecipeLikesApiArg = {
  /** ID of the RecipeLikes to update */
  id: string;
  /** RecipeLikes that needs to be added to the application */
  updateRecipeLikes: UpdateRecipeLikes;
};
export type AddRecipesApiResponse =
  /** status 201 Recipes has been created successfully. */ {
    ok?: boolean;
    data?: Recipes;
    message?: string;
  };
export type AddRecipesApiArg = {
  /** Recipes that needs to be added to the application */
  createRecipes: CreateRecipes;
};
export type GetFavoritesCountApiResponse =
  /** status 200 Favorites count retrieved successfully */ {
    ok?: boolean;
    data?: {
      assetFavoritesCount?: number;
      recipeFavoritesCount?: number;
      memoriesFavoritesCount?: number;
      totalCount?: number;
    };
    message?: string;
  };
export type GetFavoritesCountApiArg = {
  /** User ID */
  userId?: string;
  /** Subscriber ID */
  subscriberId?: string;
};
export type SearchRecipesApiResponse =
  /** status 200 Recipes retrieved successfully */ {
    ok?: boolean;
    data?: SearchRecipeResponse;
    message?: string;
  };
export type SearchRecipesApiArg = {
  /** Recipes that needs to be added to the application */
  createSearchRecipes: CreateSearchRecipes;
  /** Subscriber ID */
  subscriberId?: string;
};
export type GetRecipesByIdApiResponse =
  /** status 200 Recipes details found. */ {
    ok?: boolean;
    data?: Recipe;
    message?: string;
  };
export type GetRecipesByIdApiArg = {
  /** ID of the Recipes to retrieve */
  id: string;
};
export type UpdateRecipesApiResponse =
  /** status 200 The Recipes's details has been updated successfully */ {
    ok?: boolean;
    data?: Recipes;
    message?: string;
  };
export type UpdateRecipesApiArg = {
  /** ID of the Recipes to update */
  id: string;
  /** Recipes that needs to be added to the application */
  updateRecipes: UpdateRecipes;
};
export type DeleteRecipesApiResponse =
  /** status 200 The Recipes's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteRecipesApiArg = {
  /** ID of the Recipes to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type BulkDeleteRecipesApiResponse =
  /** status 200 Recipes bulk deleted successfully */ {
    ok?: boolean;
    data?: {
      success?: number;
      failed?: number;
    };
    message?: string;
  };
export type BulkDeleteRecipesApiArg = {
  /** flag to hard delete (true) or soft delete (false) */
  delete?: string;
  /** Recipes that needs to be added to the application */
  bulkRecipes: BulkRecipes;
};
export type BulkPrivateRecipesApiResponse =
  /** status 200 Recipes made private successfully */ {
    ok?: boolean;
    data?: {
      success?: number;
      failed?: number;
    };
    message?: string;
  };
export type BulkPrivateRecipesApiArg = {
  /** Recipes that needs to be added to the application */
  bulkRecipes: BulkRecipes;
};
export type GetRecipeSubcategoriesApiResponse = {
  ok?: boolean;
  data?: RecipeSubcategories;
  message?: string;
};
export type AddRecipeToUserFolderApiResponse =
  /** status 200 Recipe added to user folder successfully */ {
    ok?: boolean;
    data?: Recipes;
    message?: string;
  };
export type AddRecipeToUserFolderApiArg = {
  /** Recipes that needs to be added to the application */
  recipeFolder: RecipeFolder;
};
export type GetRecipesByUserFolderApiResponse =
  /** status 200 Recipes retrieved successfully */ {
    ok?: boolean;
    data?: Recipes[];
    message?: string;
  };
export type GetRecipesByUserFolderApiArg = {
  /** ID of the user folder to get recipes from */
  userFolderId: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
};

export type BulkAddRecipesToUserFolderApiResponse =
  /** status 200 Successfully added recipes to folder */ {
    ok?: boolean;
    data?: {
      /** Number of recipes successfully added */
      success?: number;
      /** Number of recipes that failed to be added */
      failed?: number;
    };
    message?: string;
  };
export type BulkAddRecipesToUserFolderApiArg = {
  /** Recipes that needs to be added to the application */
  recipeFolder: RecipeFolderBulk;
};
/** status 200 Returns list of recipe subcategories with count */
export type GetRecipeSubcategoriesApiArg = {
  /** Filter by category ID */
  categoryId?: string;
  /** Search subcategory name */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort field */
  sortby?: string;
  /** order direction (ASC/DESC) */
  orderby?: string;
};
export type Cusine = {
  count?: number;
  rows?: {
    id?: string;
    name?: string;
    status?: string;
    createdBy?: any;
    createdAt?: string;
    updatedAt?: string;
  }[];
};
export type RecipeCategories = {
  count?: number;
  rows?: {
    id: string;
    name: string;
    icon?: string;
    sortOrder?: number;
    status: string;
    createdAt: string;
    updatedAt: string;
    subcategories?: {
      id?: string;
      categoryId?: string;
      name?: string;
      icon?: string;
      sortOrder?: number;
    }[];
  }[];
};
export type RecipeComments = {
  count?: number;
  rows?: {
    id: string;
    recipeId: string;
    userId: string;
    subscriptionId: string;
    comment: string;
    status: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreateRecipeComments = {
  recipeId?: string;
  userId?: string;
  subscriptionId?: string;
  comment?: string;
  status?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type UpdateRecipeComments = {
  id?: string;
  recipeId?: string;
  userId?: string;
  subscriptionId?: string;
  comment?: string;
  status?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type RecipeCommmentsLike = {
  count?: number;
  rows?: {
    id: string;
    status: string;
    recipeId?: string;
    userId?: string;
    subscriptionId?: string;
    peopleId?: string;
    commentId?: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreateRecipeCommmentsLike = {
  recipeId?: string;
  userId?: string;
  subscriptionId?: string;
  peopleId?: string;
  commentId?: string;
  status?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type RecipeFavorites = {
  count?: number;
  rows?: {
    id: string;
    status: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    recipeId: string;
  }[];
};
export type CreateRecipeFavorites = {
  recipeId: string;
  status?: string;
  createdBy: string;
  createdAt?: string;
  updatedAt?: string;
};
export type RecipeLikes = {
  count?: number;
  rows?: {
    id: string;
    recipeId: string;
    status: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreateRecipeLikes = {
  id?: string;
  recipeId: string;
  status?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type UpdateRecipeLikes = {
  id: string;
  recipeId: string;
  status: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
};
export type Recipes = {
  id?: string;
  title?: string;
  subscriberId?: string;
  peopleId?: any;
  createdBy?: string;
  likesCount?: number;
  commentsCount?: number;
  isPrivate?: boolean;
  coverImageAssetId?: string;
  recipeAssets?: {
    id?: string;
    assetId?: string;
    asset?: {
      url?: string;
      thumbNailUrl?: string;
    };
  }[];
  user?: {
    userId?: string;
    fullName?: string;
    profileImage?: any;
  };
  creatorName?: string;
  profileImage?: string;
  person?: any;
};
export type CreateRecipes = {
  title: string;
  recipeType?: string;
  mainCourseType?: string;
  categoryId?: string;
  subcategoryId?: string;
  creatorsName?: string;
  ingredients?: string;
  instructions?: string;
  preparationTime?: string;
  cookingTime?: string;
  difficultyLevel?: string;
  cuisine?: string;
  urlLink?: string;
  thumbnailUrl?: string;
  diary?: string;
  isDiaryPrivate?: boolean;
  userFolderId?: string;
  tagIds?: string[];
  assetIds?: string[];
  status?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  isPrivate?: boolean;
  coverImageAssetId?: string;
  notes: string;
  peopleId?: string;
  subscriberId?: string;
  size?: string;
  // tags: any[];
};
export type SearchRecipeResponse = {
  count?: number;
  rows?: {
    id?: string;
    title?: string;
    subscriberId?: string;
    createdAt?: string;
    peopleId?: string;
    isFavorited?: boolean;
    likesCount?: number;
    commentsCount?: number;
    status?: string;
    isPrivate?: boolean;
    creatorName?: string;
    profileImage?: string;
    recipeAssets?: {
      id?: string;
      assetId?: string;
      isCoverImage?: boolean;
      asset?: {
        url?: string;
        thumbNailUrl?: string;
        type?: string;
        contentType?: string;
      };
    }[];
    recipeCategoryMappings?: {
      categoryId?: string;
      subcategoryId?: string;
      recipeCategory?: {
        id?: string;
        name?: string;
      };
      recipeSubcategory?: {
        id?: string;
        name?: string;
      };
    }[];
    recipeTagMappings?: {
      tagId?: string;
      recipeTag?: {
        id?: string;
        name?: string;
      };
    }[];
    user?: {
      userId?: string;
      fullName?: string;
      profileImage?: string;
    };
    person?: {
      id?: string;
      name?: string;
      profileImage?: string;
    };
    sharedWith?: {
      count?: number;
      people?: {
        peopleId?: string;
        name?: string;
        email?: string;
        profileImage?: string;
        status?: string;
      }[];
    };
  }[];
};
export type CreateSearchRecipes = {
  isFavorite?: string;
  mediaType?: string;
  peopleId?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  offset?: number;
  limit?: number;
  userFolderId?: string;
  name?: string;
  categoryId?: string;
  subcategoryId?: string;
  isTrash?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
};
export type Recipe = {
  id?: string;
  title?: string;
  subscriberId?: string;
  recipeType?: any;
  mainCourseType?: any;
  ingredients?: string;
  instructions?: string;
  preparationTime?: string;
  cookingTime?: string;
  difficultyLevel?: string;
  userFolderId?: any;
  hasOwnerAccess?: boolean;
  cuisine?: string;
  urlLink?: string;
  diary?: string;
  isDiaryPrivate?: boolean;
  peopleId?: any;
  status?: string;
  createdBy?: string;
  isPrivate?: boolean;
  createdAt?: string;
  updatedAt?: string;
  creatorsName?: string;
  creatorsId?: any;
  categoryId?: any;
  subcategoryId?: string;
  likesCount?: number;
  commentsCount?: number;
  commentLikesCount?: number;
  creatorName?: string;
  profileImage?: any;
  cusineName?: string;
  tagNames?: any;
  hasLiked?: boolean;
  hasCommented?: boolean;
  recipeCategoryMappings?: {
    categoryId?: string;
    subcategoryId?: any;
    recipeCategory?: {
      name?: string;
    };
    recipeSubcategory?: {
      name?: string;
    };
  }[];
  recipeAssets?: {
    id?: string;
    assetId?: string;
    isCoverImage?: boolean;
    url?: string;
  }[];
  recipeLikes?: any[];
  recipeComments?: {
    comment?: string;
    id?: string;
    hasCommentLiked?: boolean;
    commentsLikesCount?: number;
    recipeCommmentsLikes?: any[];
    user?: {
      userId?: string;
      fullName?: string;
      profileImage?: any;
      userDetail?: {
        profileImage?: string;
      };
    };
    createdAt?: string;
  }[];
  recipeNotes?: {
    note?: string;
    isPrivate?: boolean;
  }[];
  user: {
    fullName?: string;
    userId?: string;
  };
  person: {
    name?: string;
  };
};
export type UpdateRecipes = {
  title?: string;
  recipeType?: string;
  mainCourseType?: string;
  categoryId?: string;
  subcategoryId?: string;
  creatorsName?: string;
  ingredients?: string;
  instructions?: string;
  preparationTime?: string;
  cookingTime?: string;
  difficultyLevel?: string;
  cuisine?: string;
  urlLink?: string;
  thumbnailUrl?: string;
  diary?: string;
  isDiaryPrivate?: boolean;
  userFolderId?: string;
  notes: string;
  tagIds?: string[];
  status: string;
  createdBy?: string;
  updatedAt: string;
  isPrivate?: string;
  coverImageAssetId?: string;
  creatorName?: string;
  profileImage?: string;
  peopleId?: string;
  size?: string;
};
export type BulkRecipes = {
  ids?: string[];
  isPrivate?: boolean;
};
export type RecipeFolder = {
  recipeId?: string;
  userFolderId?: string;
};
export type RecipeFolderBulk = {
  recipeIds?: string[];
  userFolderId?: string;
};
export type RecipeSubcategories = {
  count?: number;
  rows?: {
    id: string;
    categoryId: string;
    name: string;
    icon?: string;
    sortOrder?: number;
    status: string;
    createdAt: string;
    updatedAt: string;
    category?: {
      id?: string;
      name?: string;
      icon?: string;
    };
  }[];
};
export const {
  useGetCusineQuery,
  useGetRecipeCategoriesQuery,
  useAddRecipeCommentsMutation,
  useUpdateRecipeCommentsMutation,
  useDeleteRecipeCommentsMutation,
  useAddRecipeCommmentsLikeMutation,
  useAddRecipeFavoritesMutation,
  useAddRecipeLikesMutation,
  useUpdateRecipeLikesMutation,
  useAddRecipesMutation,
  useSearchRecipesMutation,
  useGetRecipesByIdQuery,
  useUpdateRecipesMutation,
  useDeleteRecipesMutation,
  useBulkDeleteRecipesMutation,
  useBulkPrivateRecipesMutation,
  useAddRecipeToUserFolderMutation,
  useGetRecipesByUserFolderQuery,
  useGetRecipeSubcategoriesQuery,
  useRecipesCategoryListQuery,
  useGetFavoritesCountQuery,
  useBulkAddRecipesToUserFolderMutation
} = injectedRtkApi;
